/*eslint-disable react/no-set-state */
import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import PropTypes from 'prop-types'
import { DrawerHeaderBar } from '../../components/drawer/DrawerHeaderBar'
import IconButton from 'material-ui/IconButton'
import { StatefulTextField } from '../../components/common/StatefulTextField'
import NavigationClose from 'material-ui/svg-icons/navigation/close'
import { modifyBoardTemplateEntry } from '../../graphql/relay/queries/boardTemplate'
import { handleMutation } from '../../graphql/relay/queries/mutation'
import {environment} from "../../graphql/relay/env"
import { bindActionCreators } from 'redux'
import { showErrorsPg } from '../../ducks/errorspg'
import {connect} from 'react-redux'

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        showErrorsPg
      },
      dispatch
    ),
  }
}

class EditBoardTemplateEntry extends Component {
  static propTypes = {
    data: PropTypes.exact({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      boardType: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      template: PropTypes.string.isRequired
    }),
    onRequestClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    actions: PropTypes.shape({
      showErrorsPg: PropTypes.func
    }),
  }
  static contextTypes = {
    styleManager: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      id: this.props.data.id,
      name: this.props.data.name,
      boardType: this.props.data.boardType,
      description: this.props.data.description,
      template: this.props.data.template,
      nameOriginal: this.props.data.name,
      boardTypeOriginal: this.props.data.boardType,
      descriptionOriginal: this.props.data.description,
      templateOriginal: this.props.data.template
    }
  }

  handleError = () => {
    this.setState({
      isSubmitting: false
    })
  }

  handleNameUpdate = e => {
    this.setState({
      name: e.target.value,
    })
  }

  handleDescriptionUpdate = e => {
    this.setState({
      description: e.target.value,
    })
  }

  handleTemplateUpdate = e => {
    this.setState({
      template: e.target.value,
    })
  }

  onApplyHandler = () => {
    this.setState({
      isSubmitting: true
    })
    const variables = {
      boardTemplateId: this.state.id,
      boardTemplateInput: {
        name: this.state.name,
        boardType: this.state.boardType,
        description: this.state.description,
        template: this.state.template
      }
    }

    handleMutation(
      environment,
      modifyBoardTemplateEntry,
      variables,
      () => {
        this.props.onRequestClose && this.props.onRequestClose()
      },
      undefined,
      this.handleError
    )
  }

  render() {
    const { title, onRequestClose } = this.props

    const {
      name,
      boardType,
      description,
      template,
      nameOriginal,
      boardTypeOriginal,
      descriptionOriginal,
      templateOriginal
    } = this.state

    const noValueChanged = (name === nameOriginal)
      && (boardType === boardTypeOriginal)
      && (description === descriptionOriginal)
      && (template === templateOriginal)

    const anyValueUnPopulated = !name || !boardType || !description || !template

    const applyDisabled = noValueChanged || anyValueUnPopulated

    const applyButtonStyle = !applyDisabled && {
      labelStyle: {
        color: 'white',
      },
    }


    const actions = [
      <FlatButton
        key="apply"
        label="Apply"
        disabled={applyDisabled}
        {...applyButtonStyle}
        onClick={this.onApplyHandler}
      />,
    ]

    return (
      <div>
        <DrawerHeaderBar
          title={title}
          iconElementLeft={
            <IconButton onClick={onRequestClose}>
              <NavigationClose />
            </IconButton>
          }
          actions={actions}
        />

        <div className="row">
          <div className="col-xs-1" />
          <div className="col-xs-5">
            <StatefulTextField
              text={this.state.name}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Name *',
                disabled: this.state.id === 'BoardTemplate:b2ffa97b-1e59-40b6-a3f3-402f8119331b' || this.state.isSubmitting,
                floatingLabelText: 'Name *'
              }}
              onChange={this.handleNameUpdate}
              maxNumberOfChars={255}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <StatefulTextField
              text={this.state.description}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Description *',
                disabled: this.state.id === 'BoardTemplate:b2ffa97b-1e59-40b6-a3f3-402f8119331b' || this.state.isSubmitting,
                floatingLabelText: 'Description *'
              }}
              onChange={this.handleDescriptionUpdate}
              maxNumberOfChars={255}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <StatefulTextField
              text={this.state.boardType}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Board Type *',
                disabled: true,
                floatingLabelText: 'Board Type *'
              }}
              clearOnTextEntered={false}
              showCharacterCount
            />
          </div>
          <div className="col-xs-5">
            <StatefulTextField
              text={this.state.template}
              textFieldProps={{
                style: {
                  marginTop: '20px',
                  width: '99%'
                },
                floatingLabelText: 'Template *',
                multiLine: true,
                fullWidth: true,
                hintText: 'Template *',
                disabled: this.state.id === 'BoardTemplate:b2ffa97b-1e59-40b6-a3f3-402f8119331b' || this.state.isSubmitting
              }}
              inputStyleOverride={{
                overflowY: 'scroll',
                height: '340px',
                backgroundColor: 'rgb(250,250,250)',
                paddingLeft: '5px',
                border: '1px solid #afa7a7',
              }}
              maxNumberOfChars={20000}
              onChange={this.handleTemplateUpdate}
              clearOnTextEntered={false}
              showCharacterCount
            />
          </div>
          <div className="col-xs-1" />
        </div>
      </div>
    )
  }

}
export default connect(null, mapDispatchToProps)(EditBoardTemplateEntry)
